export default {
    namespaced: true,

    state: {
        Interval: null,
        EndDate: null
    },

    getters: {
        /**
         * Verifica se o pagamento é recorrente
         */
        isRecurringPayment: state => state.Interval !== null,

        /**
         * Devolve a data final da recorrência
         */
        getEndDate: state => state.EndDate,

        /**
         * Devolve o interval por extenso
         */
        getIntervalText: state => {
            const intervalSwitch = (item) => ({
                '0': 'mensalmente',
                '1': 'bimestralmente',
                '2': 'trimestralmente',
                '3': 'semestralmente',
                '4': 'anualmente'
            })[item];

            return intervalSwitch(state.Interval);
        },

        /**
         * Monta o contrato de autorização
         */
        getSubmitModel(state) {
            return {
                'RecurrentPayment': {
                    'Interval': state.Interval
                }
            };
        },
    },

    mutations: {
        /**
         * Mapeia o response da api para o módulo
         */
        setFromRequest(state, data) {
            if (data.RecurrentPayment) {
                state.Interval = data.RecurrentPayment.Interval;
                state.EndDate = data.RecurrentPayment.EndDate;
            }
        }
    }
};
